import styled, { css } from "styled-components"

const Container = styled.div<{ isOpen: boolean; backgroundStyle?: string }>`
  display: flex;
  will-change: transform;

  @media only screen and (max-width: 1340px) {
    height: 100vh;
    background: #fff;
    background: ${({ backgroundStyle }) => backgroundStyle || "linear-gradient(114deg, #4ae9ff 3.88%, #627afa 94.88%)"};
    box-shadow: -12px 1px 89px -41px rgba(0, 0, 0, 0.3);
    position: absolute;
    right: 0;
    top: 0;
    padding-top: 64px;

    flex-direction: column;
    transition: all 0.1s ease-in-out;
    width: 0;
    overflow: hidden;

    ${({ isOpen }) =>
      isOpen &&
      css`
        width: 265px;
        padding: 64px 16px 0;
      `}
  }
`

const Viewport = styled.div<{ isOpen: boolean }>`
  pointer-events: ${({ isOpen }) => (isOpen ? "auto" : "none")};
  will-change: transform;
  display: none;

  @media only screen and (max-width: 1340px) {
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(10px);
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    pointer-events: ${({ isOpen }) => (isOpen ? "auto" : "none")};
    opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
    transition: all 0.1s ease-in-out;
    display: block;
  }
`

interface MenuWrapperProps {
  isOpen: boolean
  children: React.ReactNode
  backgroundStyle?: string
  onClose: () => void
}

const MenuWrapper = ({ isOpen, children, backgroundStyle, onClose }: MenuWrapperProps) => {
  return (
    <>
      <Viewport isOpen={isOpen} onClick={onClose} />
      <Container isOpen={isOpen} backgroundStyle={backgroundStyle}>
        {children}
      </Container>
    </>
  )
}

export default MenuWrapper
